export { default } from './JoinCommunitySection'